import React, { useState } from 'react';
import './NewsItemBanner.scss';

/*
  Картинка новости. Кадрируем по 16:9, но у вертикальных картинок и у тех,
  где важны края (дипломы, грамоты), cover срезал бы суть — для них
  вписываем целиком на подложке. Решаем по натуральному соотношению,
  порог — 0.6 от 16/9.
*/
const TARGET_RATIO = 16 / 9;
const RATIO_TOLERANCE = 0.6;

const NewsItemBanner = ({ img, title }) => {
  const [fit, setFit] = useState('cover');

  const onLoad = (event) => {
    const { naturalWidth: w, naturalHeight: h } = event.target;
    if (!w || !h) return;
    setFit(Math.abs(w / h - TARGET_RATIO) > RATIO_TOLERANCE ? 'contain' : 'cover');
  };

  if (!img) return null;

  return (
    <div className={'newsItemBanner_block' + (fit === 'contain' ? ' is-contain' : '')}>
      <img src={img} alt={title || ''} onLoad={onLoad} />
    </div>
  );
};

export default NewsItemBanner;
